module.exports = __webpack_public_path__ + "img/3939784_0112.8d3825d1.jpg";